import * as Sentry from '@sentry/react'

export function logError(error, hint) {
  if (!__DEV__) {
    Sentry.captureException(error, hint ? { extra: { hint } } : undefined)
  } else {
    console.error(error)
  }
}
export function logWarning(warning) {
  if (!__DEV__) {
    Sentry.captureMessage(
      warning instanceof Error ? warning.message : String(warning),
      'warning'
    )
  } else {
    console.warn(warning)
  }
}
export function logMessage(message) {
  if (!__DEV__) {
    Sentry.captureMessage(message)
  } else {
    console.log(message)
  }
}
